import NameCheck, { doCheck } from "./NameCheck";
import Report from "../Report";
import type { IDependency } from '../../../stores/model/metamodel/dependency';

/**
 * Specialization of the NameCheck to check the name of dependency.
 *
 * Performs a NameCheck on both the master-side name and the dependent-side name
 * and returns the merged report.
 */
class DependencyNameCheck extends NameCheck<IDependency> {
  static description = 'Check dependency name';

  check(): Report {
    const reports = [
      doCheck(this.element.name.master, this, this.element),
      doCheck(this.element.name.dependent, this, this.element),
    ]
    this.report = Report.mergeReports(reports);

    return this.report;
  }
}

export default DependencyNameCheck;
